import route from '@/router/route';
import { trackEvent } from '@/modules/tracking';

export async function showSubscriptionShop(trackingName: string, documentId?: number): Promise<void> {
    await trackEvent('premium_subscription', trackingName, documentId ? `${documentId}` : '');
    sessionStorage.setItem('subscriptionProcessOriginUrl', window.location.href);
    window.location.href = route('subscription.shop.show');
}

export function showOriginUrl(): void {
    const subscriptionProcessOriginUrl = sessionStorage.getItem('subscriptionProcessOriginUrl');
    if (subscriptionProcessOriginUrl) {
        window.location.href = subscriptionProcessOriginUrl;
        return;
    }
    window.location.href = route('home.index');
}

export function showResubscriptionPage(selectedPlanId: string): void {
    const baseUrl = route('subscription.resubscribe.show');
    const params = `?plan_variant_id=${selectedPlanId}`;
    window.location.href = baseUrl + params;
}
